import Vue3Toastify, { type ToastContainerOptions, toast } from 'vue3-toastify';

import vuetify from './vuetify';

import type { App } from 'vue';

import 'vue3-toastify/dist/index.css';

/**
 * Vue plugin for setting up and configuring vue3-toastify globally.
 *
 * `vue3-toastify` mounts each toast container in its own `createApp` instance,
 * which does not inherit plugins from the host app. We use the library's
 * `useHandler` hook to install the existing Vuetify instance on every toast app
 * so Vuetify-based components (e.g. `BvBtn` -> `VBtn`) render without the
 * "Could not find defaults instance" injection error.
 */
export default {
  install(app: App) {
    app.use(Vue3Toastify, {
      transition: toast.TRANSITIONS.SLIDE,
      autoClose: 6000,
      clearOnUrlChange: false,
      position: toast.POSITION.TOP_RIGHT,
      rtl: false,
      useHandler: (toastApp: App) => {
        toastApp.use(vuetify);
      },
    } as ToastContainerOptions);
  },
};

export { ToastContainerOptions };
